import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SitesSelectionService {
  selectedSite = new BehaviorSubject(1);

  constructor() { }

  set site(value: any) {
    this.selectedSite.next(value);
    localStorage.setItem('selectedSite', value);
  }

  get site() {
    return localStorage.getItem('selectedSite');
  }
}
